import styled, { css } from "styled-components";
import Text from "../../components/Text";

const bgImg = "/images/404-bg.png";

export const StyledBg = styled.div`
  height: 100vh;
  padding: 0 16px 5vh 16px;
  background-image: url(${bgImg});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: ${({ theme }) => theme.colors.white};
`;
export const StyledStatusCodeText = styled.div`
  white-space: pre;
  font-family: Courier New;
  font-size: 27px;
  font-weight: bold;
  letter-spacing: -0.15em;
  line-height: 20px;
  @media screen and (max-width: ${({ theme }) =>
      theme.media.maxWidth.small}px) {
    font-size: 14px;
    line-height: 12px;
  }
`;
const textDescStyles = css`
  font-size: 46px;
  text-align: center;
  line-height: 1.08;
  @media screen and (max-width: ${({ theme }) =>
      theme.media.maxWidth.small}px) {
    font-size: 32px;
  }
`;
export const StyledText404Desc = styled(Text)`
  ${textDescStyles};
  max-width: 560px;
  @media screen and (max-width: ${({ theme }) =>
      theme.media.maxWidth.small}px) {
    max-width: unset;
  }
`;
export const StyledSmallText = styled(Text)`
  margin-top: 20px;
  font-size: 24px;
  line-height: 1.3;
  text-align: center;
  @media screen and (max-width: ${({ theme }) =>
      theme.media.maxWidth.small}px) {
    font-size: 16px;
  }
`;
export const StyledText500Desc = styled(Text)`
  ${textDescStyles};
`;
export const StyledButton = styled.button`
  display: inline-flex;
  align-items: center;
  border-radius: 5px;
  opacity: 0.7;
  border: 0;
  padding: 14px 20px 14px 16px;
  &:hover {
    opacity: 0.8;
  }
`;
